import styled from "styled-components";

export const Container = styled.div`
  flex: 1 0 auto;
  width: fit-content;
  max-width: 100%;
`;

export const Content = styled.div`
  padding: 0 15px;
`;
